import { render, staticRenderFns } from "./lodialog-question.vue?vue&type=template&id=89dd5470&scoped=true"
import script from "./lodialog-question.vue?vue&type=script&lang=js"
export * from "./lodialog-question.vue?vue&type=script&lang=js"
import style0 from "./lodialog-question.vue?vue&type=style&index=0&id=89dd5470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dd5470",
  null
  
)

export default component.exports